/* eslint-disable react/prop-types */
/* eslint-disable max-lines */
/* eslint-disable sort-keys */
import React, { createContext, useContext, useMemo, useState } from 'react'
import { navigate } from '@reach/router'
import { fazLoginAPI, verificaTokenAPI } from '../api/login.servico'
import axios from 'axios'
import {
  deleteInfoAssociado,
  getNomeAssociado,
  getToken,
  setNomeAssociado,
  setToken
} from '../api/autenticacao.servico'
import { getShouldShowSetup } from '../api/setup.servico'
import { obterDadosAssociado } from '../api/home.servico'
import { httpStatus, textoModalErro } from '../utils/request/httpStatus'
import { textoModalErroLogin } from '../containers/Login/constantsLogin'
import { isEmptyObject, objetoTemPropriedade } from '../utils/helpers/helpers'
import { getModalidadeDeAssinatura } from '../utils/helpers/helpersAssinatura'
import { limparCacheCategorias } from '../utils/helpers/helpersToken'
import { MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, URLS } from '../constants'
import { URLS_APP, IS_PROD } from '../config'
import { getNextRenovacaoData } from '../containers/Home/components/CardAssinatura'
import { getToggle } from '../api/toggle'
import { validateCaptcha, resetCaptcha } from '../utils/recaptcha'
const GlobalContext = createContext()

function GlobalProvider( props ) {
  // eslint-disable-next-line react/destructuring-assignment
  const [ state, setState ] = useState( !isEmptyObject( props.initialState ) ? props.initialState : {
    'actionGA': '',
    'actionVoltarGA': '',
    'dadosGlobaisAssociado': null,
    'dadosStrapi': null,
    'detalhesModalidades': null,
    'erroEsqueciSenha': null,
    'erroLogin': null,
    'erroRequisicao': null,
    'fluxoGA': '',
    'isAssociadoLogado': getToken(),
    'isTokenValido': false,
    'shouldShowSetupUserData': null,
    'shouldShowSetupSubscriptionSelect': null,
    'isSetupReativacao': null,
    'modalidadeURL': null,
    'modalidadesDaAssinatura': null,
    'nomeAssociado': getNomeAssociado(),
    'nroRenovacoesPorAssinatura': {},
    'rotaAtual': null,
    'primeiraRota': null,
    'temaGlobal': MODALIDADE_CURADORIA.cor,
    'toastGeralInfo': null,
    'shouldShowHeader': true,
    'shouldShowMenu': true,
    'showModalMgmAtHome': false,
    'urlParameters': {},
    'atMaintenance': null,
    'captcha': null,
    'validCaptcha': true,
  } )

  const value = useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <GlobalContext.Provider
      value={ value }
      { ...props }
    />
  )
}

// eslint-disable-next-line max-statements
function useGlobal() {
  const context = useContext( GlobalContext )
  if ( !context ) {
    throw new Error( 'useGlobal deve ser usado dentro de um GlobalProvider' )
  }

  const { state, setState } = context

  const setRotaAtual = rotaAtual => {
    setState( prevState => ( {
      ...prevState,
      rotaAtual
    } ) )
  }

  const setDataProximaRenovacaoAutomatica = ( newDay, id ) => {
    const assinaturas = state.dadosGlobaisAssociado.assinaturas.map( assinatura => {
      if ( assinatura.id === id ) {
        const date = getNextRenovacaoData( assinatura.dataProximaRenovacaoAutomatica )
        const splitedData = date.split( '/' )
        const newDate = `${splitedData[ 1 ]}-${splitedData[ 0 ]}-${newDay}`
        assinatura.dataProximaRenovacaoAutomatica = newDate
      }
      return assinatura
    } )
    setState( prevState => ( {
      ...prevState,
      'dadosGlobaisAssociado': {
        ...prevState.dadosGlobaisAssociado,
        assinaturas
      }
    } ) )
  }

  const setPrimeiraRota = primeiraRota => {
    setState( prevState => ( {
      ...prevState,
      primeiraRota
    } ) )
  }

  const setDetalhesModalidades = detalhesModalidades => {
    setState( prevState => ( {
      ...prevState,
      detalhesModalidades
    } ) )
  }

  const setModalidadeURL = modalidadeURL => {
    setState( prevState => ( {
      ...prevState,
      modalidadeURL
    } ) )
  }

  const setAssociadoLogado = token => {
    setState( prevState => ( {
      ...prevState,
      'isAssociadoLogado': Boolean( token )
    } ) )
  }

  const setToastGeral = info => {
    setState( prevState => ( {
      ...prevState,
      'toastGeralInfo': info
    } ) )
  }

  const setActionGA = ( actionGA ) => {
    setState( prevState => ( {
      ...prevState,
      actionGA
    } ) )
  }

  const setFluxoGA = ( fluxoGA ) => {
    setState( prevState => ( {
      ...prevState,
      fluxoGA
    } ) )
  }

  const setActionVoltarGA = ( actionVoltarGA ) => {
    setState( prevState => ( {
      ...prevState,
      actionVoltarGA
    } ) )
  }

  const setAtMaintenance = ( atMaintenance ) => {
    setState( prevState => ( {
      ...prevState,
      atMaintenance
    } ) )
  }

  const setCaptcha = ( captcha ) => {
    setState( prevState => ( {
      ...prevState,
      captcha
    } ) )
  }

  const setValidCaptcha = ( validCaptcha ) => {
    setState( prevState => ( {
      ...prevState,
      validCaptcha
    } ) )
  }

  const setNroRenovacoesPorAssinatura = ( nroRenovacoesPorAssinatura ) => {
    setState( prevState => ( {
      ...prevState,
      nroRenovacoesPorAssinatura
    } ) )
  }

  const setErroRequisicao = ( erroRequisicao, descricaoErro={} ) => {
    let erro

    if ( !isEmptyObject( descricaoErro ) && objetoTemPropriedade( descricaoErro, 'descricao' ) && objetoTemPropriedade( descricaoErro, 'titulo' ) ) {
      erro = descricaoErro
    } else if ( erroRequisicao >= httpStatus.INTERNAL_SERVER_ERROR ) {
      erro = textoModalErro[ httpStatus.INTERNAL_SERVER_ERROR ]
    } else if ( erroRequisicao === httpStatus.NOT_FOUND ) {
      erro = textoModalErro[ httpStatus.NOT_FOUND ]
    } else if ( erroRequisicao === httpStatus.BAD_REQUEST ) {
      erro = textoModalErro[ httpStatus.BAD_REQUEST ]
    }

    setState( prevState => ( {
      ...prevState,
      'erroRequisicao': erro
    } ) )
  }

  const setErroLogin = statusErro => {
    if ( statusErro === httpStatus.BAD_REQUEST ) {
      setState( prevState => ( {
        ...prevState,
        'erroLogin': textoModalErroLogin[ httpStatus.BAD_REQUEST ]
      } ) )
    } else if ( !statusErro ) {
      setState( prevState => ( {
        ...prevState,
        'erroLogin': null
      } ) )
    } else {
      setErroRequisicao( statusErro )
    }
  }

  const setErroEsqueciSenha = erroResponse => {
    if ( erroResponse?.status === httpStatus.BAD_REQUEST ) {
      const [ { message } ] = erroResponse.data.errors
      setState( prevState => ( {
        ...prevState,
        'erroEsqueciSenha': message
      } ) )
    } else if ( !erroResponse ) {
      setState( prevState => ( {
        ...prevState,
        'erroEsqueciSenha': null
      } ) )
    } else {
      setErroRequisicao( erroResponse.status )
    }
  }

  const setShowModalMgmAtHome = ( showModalMgmAtHome ) => {
    setState( prevState => ( {
      ...prevState,
      showModalMgmAtHome
    } ) )
  }

  const setDadosGlobaisAssociado = dadosAssociado => {
    let modalidadeDadosAssociado
    if ( dadosAssociado ) {
      if ( !isEmptyObject( dadosAssociado ) && objetoTemPropriedade( dadosAssociado, 'assinaturas' ) ) {
        modalidadeDadosAssociado = getModalidadeDeAssinatura( dadosAssociado.assinaturas )
      }
    }

    setState( prevState => ( {
      ...prevState,
      'dadosGlobaisAssociado': dadosAssociado,
      'modalidadesDaAssinatura': modalidadeDadosAssociado,
      'temaGlobal': modalidadeDadosAssociado?.includes( MODALIDADE_CURADORIA.visualizacao ) ? MODALIDADE_CURADORIA.cor : MODALIDADE_INEDITOS
    } ) )
  }

  const setUrlParameters = ( rawUrlParameters ) => {
    setState( prevState => ( {
      ...prevState,
      'urlParameters': { ...prevState.urlParameters, ...rawUrlParameters }
    } ) )
  }

  const getDadosGlobaisAssociado = async( type ) => {
    try {
      const resposta = await obterDadosAssociado()
      const { 'data': dados } = resposta
      if ( !isEmptyObject( dados ) ) {
        if ( type === 'anual' ) {
          const { modalidadeURL } = state
          const modalidade = modalidadeURL === 'curadoria' ? 'Curadoria' : 'Inéditos'

          const { dadosGlobaisAssociado } = state
          const assinatura = dadosGlobaisAssociado.assinaturas.find( ass => ass.modalidade === modalidade )
          const newDados = dados.assinaturas.find( ass => ass.modalidade === modalidade )
          if ( assinatura.controles.mesTagUltimoPedidoValido === newDados.controles.mesTagUltimoPedidoValido ) {
            dados.assinaturas.forEach( ass => {
              if ( ass.modalidade === modalidade ) {
                const data = ass.controles.mesTagUltimoPedidoValido.replace( '(', '' ).replace( ')', '' )
                  .split( ',' )
                const yearPlus1 = parseInt( data[ 0 ], 10 ) + 1
                ass.controles.mesTagUltimoPedidoValido = `('${yearPlus1},${data[ 1 ]},${data[ 2 ]}')`
              }
            } )
          }
        }
        setDadosGlobaisAssociado( dados )
        setDetalhesModalidades( dados.modalidades )
        if ( !isEmptyObject( dados.associado ) ) {
          const [ nome ] = dados.associado.nome.split( ' ', 1 )
          setNomeAssociado( nome )
        }
      }
    } catch ( erros ) {
      if ( window.newrelic ) {
        window.newrelic.noticeError( erros )
      }

      if ( erros && ( erros.request || erros.response ) ) {
        setErroRequisicao( erros.response.status || erros.request.status )
      }
    }
  }

  const verificarToken = async token => {
    try {
      const resposta = await verificaTokenAPI( token )
      if ( resposta.data.token ) {
        setAssociadoLogado( Boolean( resposta.data.token ) )
        setToken( token )
      }
    } catch ( erros ) {
      if ( erros && ( erros.request || erros.response ) ) {
        setErroLogin( erros.response.status || erros.request.status )
      }
    }
  }

  const resetCaptchaToken = () => {
    resetCaptcha()
    setCaptcha( null )
  }

  const fazLogin = async( { username, password }, setLoading ) => {
    deleteInfoAssociado()
    limparCacheCategorias()
    try {
      const captcha = validateCaptcha()
      const resposta = await fazLoginAPI( { password, username, captcha } )
      const { token } = resposta.data
      if ( token ) {
        setErroRequisicao( '' )
        verificarToken( token )
      }
    } catch ( erros ) {
      resetCaptchaToken()
      if ( erros && ( erros.request || erros.response ) ) {
        setErroLogin( erros.response.status || erros.request.status )
      }
      setLoading( false )
    }
  }

  const getDadosStrapi = async() => {
    try {
      if ( !state.dadosStrapi ) {
        const publicationState = IS_PROD ? '_publicationState=live' : '_publicationState=preview&published_at_null=true'
        const strapiApiUrl = `https://taglivros.com/cms/api/adas?${publicationState}&_limit=1&_sort=id:DESC`
        const { data } = await axios.get( strapiApiUrl )
        setState( prevState => ( {
          ...prevState,
          'dadosStrapi': { data }
        } ) )
        return { data }
      } else {
        return state.dadosStrapi
      }
    } catch ( erros ) {
      // eslint-disable-next-line no-console
      console.log( 'Error retrieving strapi data' )
    }
  }

  const fazLogout = ( queryParams ) => {
    deleteInfoAssociado()
    limparCacheCategorias()
    setState( prevState => ( {
      ...prevState,
      'isAssociadoLogado': false,
      'isTokenValido': false
    } ) )

    let logoutUrl = ``

    if ( URLS_APP.BASE_PATH ) {
      logoutUrl = `${logoutUrl}${URLS_APP.BASE_PATH}`
    }

    logoutUrl = `${logoutUrl}/${URLS.LOGIN}`

    if ( queryParams && queryParams.redirectTo ) {
      logoutUrl = `${logoutUrl}?redirectTo=${queryParams.redirectTo}`
      if ( queryParams.coupon ) {
        logoutUrl = `${logoutUrl}&cupom=${queryParams.coupon}`
      }
    }

    navigate( logoutUrl )
  }

  const setShouldShowSetupUserData = ( shouldShowSetupUserData ) => {
    setState( prevState => ( {
      ...prevState,
      shouldShowSetupUserData
    } ) )
  }

  const setShouldShowSetupSubscriptionSelect = ( shouldShowSetupSubscriptionSelect ) => {
    setState( prevState => ( {
      ...prevState,
      shouldShowSetupSubscriptionSelect
    } ) )
  }

  const setIsSetupReativacao = ( isSetupReativacao ) => {
    setState( prevState => ( {
      ...prevState,
      isSetupReativacao
    } ) )
  }

  const fetchShouldShowSetup = async() => {
    const tipoEvento = {
      'ofertaUnica': 'OFERTA_UNICA',
      'checkoutOnePage': 'CHECKOUT_ONEPAGE'
    }
    const shouldShowSetupUserData = await getShouldShowSetup()
    const isCheckoutOnePage = shouldShowSetupUserData.tipo === tipoEvento.checkoutOnePage
    const isOfertaUnica = shouldShowSetupUserData.tipo === tipoEvento.ofertaUnica
    setIsSetupReativacao( shouldShowSetupUserData.isReativacao )
    if ( isCheckoutOnePage || ( shouldShowSetupUserData.setupEmAndamento && isOfertaUnica ) ) {
      setShouldShowSetupUserData( shouldShowSetupUserData.exibir )
      setShouldShowSetupSubscriptionSelect( false )
    } else {
      setShouldShowSetupUserData( false )
      setShouldShowSetupSubscriptionSelect( shouldShowSetupUserData.exibir )
    }
  }

  const setShouldShowHeader = ( shouldShowHeader ) => {
    setState( prevState => ( {
      ...prevState,
      shouldShowHeader
    } ) )
  }

  const setShouldShowMenu = ( shouldShowMenu ) => {
    setState( prevState => ( {
      ...prevState,
      shouldShowMenu
    } ) )
  }

  const getRedirectToParameter = () => {
    const queryString = new URLSearchParams( window.location.search )
    const redirectTo = queryString.get( 'redirectTo' )
    if ( redirectTo ) {
      const redirectIsValid = redirectTo.startsWith( URLS_APP.BASE_PATH ? `${URLS_APP.BASE_PATH}/` : '/' )
      return redirectIsValid ? redirectTo : null
    }
    return null
  }

  const getCouponParameter = () => {
    const queryString = new URLSearchParams( window.location.search )
    const coupon = queryString.get( 'cupom' )
    if ( coupon ) {
      setUrlParameters( { coupon } )
      return coupon
    }
    return null
  }

  const verifyAtMaintenance = async() => {
    const result = await getToggle( 'maintenance_ada' )
    setAtMaintenance( result )
    return result
  }

  return {
    'actionGA': state.actionGA,
    'actionVoltarGA': state.actionVoltarGA,
    'dadosGlobaisAssociado': state.dadosGlobaisAssociado,
    'dadosStrapi': state.dadosStrapi,
    'detalhesModalidades': state.detalhesModalidades,
    'erroEsqueciSenha': state.erroEsqueciSenha,
    'erroLogin': state.erroLogin,
    'erroRequisicao': state.erroRequisicao,
    'eventGACategoria': state.eventGACategoria,
    'fluxoGA': state.fluxoGA,
    'isAssociadoLogado': state.isAssociadoLogado,
    'isSetupReativacao': state.isSetupReativacao,
    'modalidadesDaAssinatura': state.modalidadesDaAssinatura,
    'modalidadeURL': state.modalidadeURL,
    'nomeAssociado': state.nomeAssociado,
    'nroRenovacoesPorAssinatura': state.nroRenovacoesPorAssinatura,
    'primeiraRota': state.primeiraRota,
    'rotaAtual': state.rotaAtual,
    'shouldShowHeader': state.shouldShowHeader,
    'shouldShowMenu': state.shouldShowMenu,
    'shouldShowSetupSubscriptionSelect': state.shouldShowSetupSubscriptionSelect,
    'shouldShowSetupUserData': state.shouldShowSetupUserData,
    'showModalMgmAtHome': state.showModalMgmAtHome,
    'temaGlobal': state.temaGlobal,
    'toastGeralInfo': state.toastGeralInfo,
    'urlParameters': state.urlParameters,
    'atMaintenance': state.atMaintenance,
    'captcha': state.captcha,
    'validCaptcha': state.validCaptcha,
    fazLogin,
    fazLogout,
    fetchShouldShowSetup,
    getCouponParameter,
    getDadosGlobaisAssociado,
    getDadosStrapi,
    getRedirectToParameter,
    setActionGA,
    setActionVoltarGA,
    setDadosGlobaisAssociado,
    setDataProximaRenovacaoAutomatica,
    setDetalhesModalidades,
    setErroEsqueciSenha,
    setErroLogin,
    setErroRequisicao,
    setFluxoGA,
    setIsSetupReativacao,
    setModalidadeURL,
    setNroRenovacoesPorAssinatura,
    setPrimeiraRota,
    setRotaAtual,
    setShouldShowHeader,
    setShouldShowMenu,
    setShouldShowSetupSubscriptionSelect,
    setShouldShowSetupUserData,
    setShowModalMgmAtHome,
    setToastGeral,
    verificarToken,
    verifyAtMaintenance,
    setCaptcha,
    setValidCaptcha,
  }
}

export { GlobalProvider, useGlobal }
